import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { Subject } from "rxjs/Subject";
import { Brand, BrandMaster, BrandCategory } from "../../interface/brand";
import { Site } from '../../interface/site';
import { Zone } from "../../interface/zone";

@Injectable()
export class BrandService {
  private brandAction = new Subject();

  constructor(private httpClient: HttpClient) { }

  //list of all Brands
  list(filter = ""): Observable<Brand[]> {
    return this.httpClient.get<Brand[]>("brand?" + filter);
  }

  //list of Brand Masters
  brandMasterList(name = ""): Observable<BrandMaster[]> {
    let filter = "";
    if (name) {
      filter = "?limit=5&where[brandName]=" + name;
    }
    return this.httpClient.get<BrandMaster[]>("brand/master" + filter);
  }

  //list of Brand Category
  brandCategoryList(name = ""): Observable<BrandCategory[]> {
    let filter = "";
    if (name) {
      filter = "?limit=5&where[brandCategoryName]=" + name;
    }
    return this.httpClient.get<BrandCategory[]>("brand/category" + filter);
  }

  //Create Brand
  create(form): Observable<any> {
    let body = form;
    return this.httpClient.post("brand", body);
  }

  //Update Brand
  update(form): Observable<any> {
    let body = form;
    return this.httpClient.patch("brand", body);
  }

  delete(brandId): Observable<any> {
    return this.httpClient.delete("brand/" + brandId);
  }

  getAction(): Observable<any> {
    return this.brandAction.asObservable();
  }

  sendAction(action, id) {
    this.brandAction.next({ action: action, id: id });
  }

  siteList(): Observable<Site[]> {
    return this.httpClient.get<Site[]>('site?fields=siteName,isActive,address');
  }

  zoneList(name = "", siteId = ""): Observable<Zone[]> {
    let filter = "";
    // if (name) {
    //   filter = "?limit=5&where[zoneName]=" + name + "&where[siteId]="+siteId;
    // }
    filter = "?where[siteId]=" + siteId;
    return this.httpClient.get<Zone[]>('zone' + filter);
  }

  createMap(id, mapped): Observable<any> {
    let body = mapped;
    return this.httpClient.post('brand/' + id + '/map', body);
  }

  deleteMapping(brandId, mapped): Observable<any> {
    let body = mapped;
    return this.httpClient.patch('brand/' + brandId + '/map', body);
  }
}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/services/brand/brand.service.ts